<template>
  <v-container fluid style="max-width: 1440px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text }}
        </v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <v-data-table :loading="loading" :headers="encabezadoAdminSuper" :items="depreciaciones" :items-per-page="15"
          class="elevation-3" dense>
          <template v-slot:top>
            <v-form v-model="isValid">
              <v-toolbar flat>
                <!-- Formulario busqueda de venta usuario -->
                <v-toolbar-title class="hidden-sm-and-down">DEPRECIACIÓN</v-toolbar-title>
                <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>

                <!-- <v-autocomplete dense small-chips @keyup="selectBien()" :search-input.sync="buscarCodBien"
                  v-model="grupoBienes" :items="bienes" label="Códigos modulares"
                  :rules="[v => !!v || 'Nombres es requerido']" clearable hide-details class="mr-1"
                  @change="depreciaciones = []" :disabled="!desabilitarBuscar" multiple></v-autocomplete> -->

                <v-autocomplete dense small-chips v-model="grupoBienes" :items="bienes" label="Códigos modulares"
                  :rules="[v => !!v || 'Nombres es requerido']" clearable hide-details class="mr-1"
                  @change="depreciaciones = [], listar()" :disabled="!desabilitarBuscar" multiple></v-autocomplete>

                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="300px">
                  <template v-slot:activator="{ on }">
                    <v-text-field dense v-model="fecha_formateada" label="Fecha Deprec." readonly v-on="on" hide-details
                      class="mr-1" style="max-width: 90px;">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="fecha" @input="menu = false" @change="fechaseleccionada(fecha), listar()">
                  </v-date-picker>
                </v-menu>


                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small color="success" @click="crearXLSX()" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" v-bind="attrs" v-on="on">
                      <v-icon>summarize</v-icon>
                    </v-btn>
                  </template>
                  <span>Reporte Excel</span>
                </v-tooltip>

                <!-- Fin Formulario Busqueda de venta usuario-->
              </v-toolbar>
            </v-form>
          </template>
          <!-- Formatear detalle -->
          <template v-slot:item.codbien="{ item }">
            <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
          </template>
          <template v-slot:item.valordq="{ item }">
            <div class="text-right">
              {{ item.valordq | formatearNumero }}
            </div>
          </template>
          <template v-slot:item.depreciacion="{ item }">
            {{ item.depreciacion * 100 + '%' }}
          </template>
          <template v-slot:item.depreciacionanual="{ item }">
            <div class="text-right">
              {{ item.valordq * item.depreciacion | formatearNumero }}
            </div>
          </template>
          <template v-slot:item.calculodepreciacion="{ item }">
            <div class="text-right">
              {{ (item.valordq * (item.depreciacion / 12) * item.totalmeses) | formatearNumero }}
            </div>
          </template>
          <template v-slot:item.depreciacionacumulada="{ item }">
            <div class="text-right">
              {{ (item.valordq * (item.depreciacion / 12) * item.totalmeses) >= item.valordq
                ? item.valordq - 1 : (item.valordq * (item.depreciacion / 12) * item.totalmeses) | formatearNumero }}
            </div>
          </template>
          <template v-slot:item.valorreal="{ item }">
            <div class="text-right">
              {{ item.valordq - ((item.valordq * (item.depreciacion / 12) * item.totalmeses) >= item.valordq
                ? item.valordq - 1 : (item.valordq * (item.depreciacion / 12) * item.totalmeses)) | formatearNumero }}
            </div>
          </template>
          <!-- Fin Formatear detalle -->
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex"; //Importamos para llamar a los elementos
import moment from "moment";
import ExcelJS from 'exceljs';

export default {
  data() {
    return {
      depreciaciones: [],
      dialog: false,

      encabezadoAdminSuper: [
        { text: "C. Patrimonial", value: "codbien", sortable: false, width: 135 },
        { text: "Descripcion", value: "tbdescripcion", sortable: false },
        { text: "Cuenta", value: "cuenta", sortable: false, align: "center" },
        { text: "Fecha Origen", value: "fec_reg", sortable: false, align: "center" },
        { text: "Valor Adquisición", value: "valordq", sortable: false, align: "center" },
        { text: "Meses", value: "totalmeses", sortable: false, align: "center" },
        { text: "%", value: "depreciacion", sortable: false, align: "center" },
        { text: "Vida Util", value: "vidautil", sortable: false, align: "center" },
        { text: "Depreciación Anual", value: "depreciacionanual", sortable: false, align: "center" },
        { text: "Calculo Depreciación", value: "calculodepreciacion", sortable: false, align: "center" },
        { text: "Depreciación Acumulada", value: "depreciacionacumulada", sortable: false, align: "center" },
        { text: "Valor Real", value: "valorreal", sortable: false, align: "center" },
      ],
      grupoBienes: [],
      bienes: [],

      fecha_formateada: "",
      fecha: moment().format("YYYY-MM-DD"),
      modal: false,
      menu: false,

      desabilitarBuscar: true,
      desabilitar: false,
      isValid: true,
      loading: false,
      alerta: { snackbar: false, color: "", text: "" },

      idempresa: "",
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]), // Llamamos a state
  },

  created() {
    this.idempresa = parseInt(this.usuarioState.idempresa);
    this.fechaseleccionada(this.fecha);
    this.selectBien();
    this.listar();
  },

  methods: {
    fechaseleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_formateada = ddmmyy;
    },

    /* Listar venta usuario */

    listar() {
      let me = this;
      me.desabilitar = true;
      me.loading = true;

      axios.get("api/Bienes/ReporteDepreciacion", {
        params: {
          idempresa: parseInt(me.idempresa),
          fechadeprec: me.fecha,
          grupobien: me.grupoBienes,
        },
        paramsSerializer: (params) => {
          return Object.keys(params)
            .map(key => {
              const value = params[key];
              if (Array.isArray(value)) {
                // Si el valor es un array, lo serializa como ?key=value1&key=value2...
                return value
                  .map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
                  .join('&');
              } else {
                // Si el valor no es un array, se serializa de forma estándar
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
              }
            })
            .join('&');
        }
      })
        .then(function (response) {
          me.depreciaciones = response.data;

          me.desabilitar = false;
          me.loading = false;
          //console.log(me.depreciaciones);
        })
        .catch((err) => {
          me.desabilitar = false;
          me.loading = false;
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "Ocurrio un error";
          //console.log(err.response);
        });
    },
    /* Fin Listar venta usuario */

    // Seleccionar usuario por busqueda
    selectBien() {
      let me = this;
      var bienesArray = [];

      axios.get("api/Bienes/SelectCodBienFiltro", {
        params: {
          idempresa: parseInt(me.idempresa),
        },
      })
        .then(function (response) {
          bienesArray = response.data;
          bienesArray.map(function (x) {
            me.bienes.push({
              text: x.codbien,
              value: x.idbien
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Crear excel */
    async crearXLSX() {
      // Estilo para el título principal
      const titleStyle = {
        font: { name: 'Calibri', size: 16, bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center' }
      };

      // Estilo para las etiquetas de la información del activo (ej: "Código SBN")
      const headerLabelStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
      };

      // Estilo para las cabeceras de la tabla de depreciación
      const tableHeaderStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6E0B4' } }, // Color verde claro
      };
      const tableHeaderStyle2 = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFCE4D6' } }, // Color anaranjado claro
      };

      // 1. Crear un nuevo libro y una hoja de cálculo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Depreciación');

      // Crear una imagen de base64
      const Base64 = 'data:image/png;base64,' + this.empresaState.logo;
      const logoImage = workbook.addImage({
        base64: Base64,
        extension: 'jpeg',
      });

      // Agregar la imagen a la hoja de cálculo
      worksheet.addImage(logoImage, {
        ext: { width: 50, height: 65 },
      });

      // 2. Definir el ancho de las columnas para que se ajusten al contenido
      worksheet.getColumn('A').width = 6;
      worksheet.getColumn('B').width = 15;
      worksheet.getColumn('C').width = 50;
      worksheet.getColumn('D').width = 15;
      worksheet.getColumn('E').width = 11;
      worksheet.getColumn('F').width = 16;
      worksheet.getColumn('G').width = 11;
      worksheet.getColumn('H').width = 8;
      worksheet.getColumn('I').width = 9;
      worksheet.getColumn('J').width = 11;
      worksheet.getColumn('K').width = 9;
      worksheet.getColumn('L').width = 16;
      worksheet.getColumn('M').width = 16;
      worksheet.getColumn('N').width = 16;
      worksheet.getColumn('O').width = 16;
      worksheet.getColumn('P').width = 16;
      worksheet.getColumn('Q').width = 16;
      worksheet.getColumn('R').width = 16;

      // 3. Añadir el título principal y combinar celdas
      worksheet.addRow(['REPORTE DE BIENES ACTIVOS FIJOS Y SU DEPRECIACIÓN']);
      worksheet.mergeCells('A1:R1');
      worksheet.getCell('A1').style = titleStyle;
      worksheet.getRow(1).height = 30;

      worksheet.getCell('C2').value = 'ENTIDAD: ' + this.empresaState.nombre;
      worksheet.getCell('C2').style = headerLabelStyle;
      worksheet.getCell('O2').value = 'FECHA DE CÁLCULO DE DEPRECIACIÓN: ' + this.fecha_formateada;
      worksheet.getCell('O2').style = headerLabelStyle;

      worksheet.getCell('C3').value = 'DEPENDENCIA: AREA DE GESTIÓN DE BIENES MUEBLES';
      worksheet.getCell('C3').style = headerLabelStyle;

      // 4. Añadir la información del activo (filas 3 a 8)

      // 5. Añadir un espacio y la cabecera de la tabla de depreciación
      worksheet.mergeCells('A4:F4');
      worksheet.getCell('A4').value = 'RELACIÓN DE ACTIVOS FIJOS VALORIZADOS';
      worksheet.getCell('A4').style = tableHeaderStyle;

      worksheet.mergeCells('G4:R4');
      worksheet.getCell('G4').value = 'CALCULO DE DEPRECIACIÓN CONTABLE DE ACTIVOS FIJOS';
      worksheet.getCell('G4').style = tableHeaderStyle2;

      const headerRow = worksheet.addRow(['ITEM', 'CÓDIGO PATRIMONIAL', 'DESCRIPCIÓN', 'CUENTA CONTABLE', 'FECHA ORIGEN', 'VALOR ADQUISICIÓN', 'AJUSTE AL', 'TOTAL MESES', '% ANUAL', '% MENSUAL', 'AÑOS DE VIDA', 'DEPRECIACIÓN ANUAL', 'DEPRECIACIÓN MENSUAL', 'CALCULO DE DEPRECIACIÓN', 'DEPRECIACIÓN ACUMULADA', 'VALOR AJUSTADO', 'DIFERENCIA X AJUSTAR', 'VALOR REAL']);
      headerRow.eachCell(cell => {
        headerRow.eachCell((cell, colNumber) => {
          cell.style = {
            ...tableHeaderStyle,
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: colNumber <= 6 ? 'FFC6E0B4' : 'FFFCE4D6' // Verde claro y anaranjado claro
              }
            }
          };
        });
      });

      //
      // 6. Añadir los datos de la tabla de depreciación
      let itemCounter = 1;

      let totalValordq = 0;
      let totalDepAnual = 0;
      let totalDepAcumulada = 0;
      let totalValorReal = 0;

      this.depreciaciones.forEach(rowData => {
        let depMensualPorc = rowData.depreciacion / 12;
        let depAnualmont = rowData.valordq * rowData.depreciacion;
        let depMensualMont = rowData.valordq * depMensualPorc * rowData.totalmeses;
        let depAcumulada = depMensualMont >= rowData.valordq ? rowData.valordq - 1 : depMensualMont;
        let difAjuste = rowData.valordq - depAcumulada;
        let valorReal = difAjuste <= 1 ? 1 : difAjuste;

        // Acumular totales
        totalValordq += rowData.valordq;
        totalDepAnual += depAnualmont;
        totalDepAcumulada += depAcumulada;
        totalValorReal += valorReal;

        const row = worksheet.addRow([
          itemCounter++,
          rowData.codbien.length == '12' ? rowData.codbien : rowData.codbienint + '-' + rowData.codinterno,
          rowData.tbdescripcion,
          rowData.cuenta,
          rowData.fec_reg,
          rowData.valordq,
          rowData.fechacalculodep,
          rowData.totalmeses,
          rowData.depreciacion * 100 + '%',
          this.cm.roundOut(depMensualPorc * 100, 2) + '%',
          rowData.vidautil,
          this.cm.roundOut(depAnualmont, 2),
          this.cm.roundOut(depAnualmont / 12, 2),
          this.cm.roundOut(depMensualMont, 2),
          this.cm.roundOut(depAcumulada, 2),
          this.cm.roundOut(depAcumulada, 2),
          difAjuste, // No redondear existe un error de NaN
          this.cm.roundOut(valorReal, 2),
        ]);

        // Aplicar estilos y bordes
        function aplicarBorde(row, startCol, endCol, colorARGB) {
          for (let col = startCol; col <= endCol; col++) {
            const cell = row.getCell(col);
            cell.border = {
              top: { style: 'thin', color: { argb: colorARGB } },
              left: { style: 'thin', color: { argb: colorARGB } },
              bottom: { style: 'thin', color: { argb: colorARGB } },
              right: { style: 'thin', color: { argb: colorARGB } },
            };
          }
        }
        aplicarBorde(row, 1, 6, 'FFC6E0B4');    // Bordes verde claro en columnas 1 a 5
        aplicarBorde(row, 7, 18, 'FFFCE4D6');   // Bordes anaranjado claro en columnas 6 a 18

        // Centrar la celda
        [1, 2, 4, 5, 7, 8, 9, 10, 11].forEach(col => {
          row.getCell(col).alignment = { horizontal: 'center' };
        });

        // Formato y estilo para columnas
        [6, 12, 13, 14, 15, 16, 17, 18].forEach(col => {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00'; // incluye símbolo de soles
          cell.alignment = { horizontal: 'right' };
          cell.font = { name: 'Calibri', size: 11 };
        });
      });

      const totalRow = worksheet.addRow([
        '', '', '', '', 'TOTALES:',
        this.cm.roundOut(totalValordq, 2), // columna 6
        '', '', '', '', '',
        this.cm.roundOut(totalDepAnual, 2), // columna 12
        '', '',
        this.cm.roundOut(totalDepAcumulada, 2), // columna 15
        '', '',
        this.cm.roundOut(totalValorReal, 2) // columna 18
      ]);

      // Aplicar estilo a totales
      totalRow.eachCell((cell, colNumber) => {
        cell.font = { bold: true };

        // Aplica color de fondo a columnas específicas
        if ([6, 12, 15, 18].includes(colNumber)) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDBDBDB' } // Gris claro
          };

          // Aplica formato numérico (dos decimales, separador de miles)
          cell.numFmt = '#,##0.00';
        }
      });

      // Ocultar las líneas de división de la hoja de cálculo
      worksheet.views = [
        {
          showGridLines: false
        }
      ];

      // 7. Generar el archivo y descargarlo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Depreciacion.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /* Fin Crear excel */
  },
};
</script>
